module.exports = __webpack_public_path__ + "img/open-apis-practices.cf813023.svg";